import { addPermissionsToRoute } from '@/myq-core';

const routes = {
  name: 'DataEntry',
  icon: 'mdi-file-edit-outline',
  path: '/reports/timhortons/dataEntry/',
  children: [
    {
      path: '/reports/timhortons/dataEntry/crewTrainingHours',
      name: 'Crew Training Hours',
      meta: { id: 'reports-thCrewTrainingHours' },
      component: () => import('./crewTrainingHours.vue'),
      ...addPermissionsToRoute(['thCrewTrainingHours']),
    },
    {
      path: '/reports/timhortons/dataEntry/overtimeAllowance',
      name: 'Overtime Allowance',
      meta: { id: 'reports-thOvertimeAllowance' },
      component: () => import('./overtimeAllowance.vue'),
      ...addPermissionsToRoute(['thOvertimeAllowance']),
    },
    {
      path: '/reports/timhortons/dataEntry/managementLabor',
      name: 'Management Labor',
      meta: { id: 'reports-thManagementLabor' },
      component: () => import('./managementLabor/managementLabor.vue'),
      ...addPermissionsToRoute(['thManagementLabor']),
    },
    {
      path: '/reports/timhortons/dataEntry/storeClosingTime',
      name: 'Store Closing Time',
      meta: { id: 'reports-thStoreClosingTime' },
      component: () => import('./storeClosingTime.vue'),
      ...addPermissionsToRoute(['thStoreClosingTime']),
    },
    {
      path: '/reports/timhortons/dataEntry/inventoryItemGroup',
      name: 'Inventory Item Group',
      meta: { id: 'reports-thInventoryItemGroup'},
      component: () => import('./inventoryItemGroup/inventoryItemGroup.vue'),
      ...addPermissionsToRoute(['thInventoryItemGroup']),
    },
  ]
};

export default routes;